import React from 'react';
import clsx from 'clsx';
import styles from '../FundingHistory.module.scss';
import { FUNDING_AMOUNT_HEADER_ID } from '../constants';

interface SummaryRowProps {
    title: string;
    amount: number;
    headers: Array<{ id: string; label: string }>;
}

function SummaryRow({ title, amount, headers }: SummaryRowProps) {
    const amountIndex = headers.findIndex((header) => header.id === FUNDING_AMOUNT_HEADER_ID);
    return (
        <div className={clsx(styles.tableRow, styles.totalsRow)}>
            <div className={styles.rowItem} style={{ gridColumn: `1 / span ${amountIndex}` }}>
                {title}
            </div>
            <div className={clsx(styles.rowItem, styles.alignRight)}>{amount?.toFixed(2)} Cr</div>
            {headers.slice(amountIndex + 1).map((header) => (
                <div key={header.id} className={styles.rowItem}></div>
            ))}
        </div>
    );
}

export default SummaryRow;
